export default function PHP_basename() {
  return (
    <div>
      <h1>PHP_basename</h1>
    </div>
  );
}
